import { InternalHashMapmpvpylj0ut6l as InternalHashMap } from './InternalHashMap.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var EmptyHolderClass;
function EmptyHolder() {
  if (EmptyHolderClass === VOID) {
    class $ {
      constructor() {
        EmptyHolder_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = InternalHashMap().ia(0);
        this_0.tb();
        tmp.wb_1 = LinkedHashMap().dc(this_0);
      }
    }
    initMetadataForObject($, 'EmptyHolder');
    EmptyHolderClass = $;
  }
  return EmptyHolderClass;
}
var EmptyHolder_instance;
function EmptyHolder_getInstance() {
  if (EmptyHolder_instance === VOID)
    new (EmptyHolder())();
  return EmptyHolder_instance;
}
function init_kotlin_collections_LinkedHashMap(_this__u8e3s4) {
}
var LinkedHashMapClass;
function LinkedHashMap() {
  if (LinkedHashMapClass === VOID) {
    class $ extends HashMap() {
      static ec() {
        var $this = this.r8();
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static fc(initialCapacity) {
        var $this = this.f9(initialCapacity);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static gc(original) {
        var $this = this.g9(original);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static dc(internalMap) {
        var $this = this.q8(internalMap);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      f8() {
        this.o8_1.tb();
        var tmp;
        if (this.q2() > 0) {
          tmp = this;
        } else {
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = EmptyHolder_getInstance().wb_1;
        }
        return tmp;
      }
      o6() {
        return this.o8_1.q9();
      }
    }
    initMetadataForClass($, 'LinkedHashMap', $.ec, VOID, [KtMutableMap()]);
    LinkedHashMapClass = $;
  }
  return LinkedHashMapClass;
}
//region block: exports
export {
  LinkedHashMap as LinkedHashMap1zhqxkxv3xnkl,
};
//endregion

//# sourceMappingURL=LinkedHashMap.mjs.map
